<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/jyzn">就医指南</router-link> >
      <router-link to="/jyzn/lianxi">联系我们</router-link>
    </div>

    <div class="container-width x-article">
      <div class="title">联系我们</div>
      <div v-for="(item, index) in list" :key="index" class="l-content">
        <div class="list">
          {{ item.title }}
        </div>
        <div class="description" v-html="item.description"></div>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../service/jyzn";
import BANNER from "../../components/banner/jyzn";
export default {
  name: "LIANXI",
  data() {
    return {
      navigationData: [
        {
          name: "就医须知",
          path: "/jyzn",
        },
        {
          name: "门诊就诊流程图",
          path: "/jyzn/liucheng",
        },
        {
          name: "楼层分布",
          path: "/jyzn/fenbu",
        },
        {
          name: "乘车路线",
          path: "/jyzn/luxian",
        },
        {
          name: "联系我们",
          path: "/jyzn/lianxi",
        },
      ],
      currentPath: "/jyzn/lianxi",
      pageIndex: 1,
      pageSize: 1000,
      totalPages: 1,
      currentPage: 1,
      list: {},
      total: 0,
    };
  },
  components: {
    BANNER,
  },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {};
      service.getContactusList(parmes, (res) => {
        this.list = res.content || [];
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.x-article {
  -webkit-transition: all 0.5s ease 0s;
  -moz-transition: all 0.5s ease 0s;
  transition: all 0.5s ease 0s;
  box-shadow: 4px 4px #ececec;
  margin-bottom: 50px;
  border: 1px solid #ebebeb;
  border-top: none;
  box-sizing: border-box;

  .title {
    padding-top: 30px;
    padding-bottom: 30px;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #ebebeb;
    font-size: 1.4rem;
  }
  .l-content {
    padding: 0 50px 50px 50px;
    .list {
      margin-top: 50px;
      font-size: 1.2rem;
      background: #00479d;
      color: #fff;
      cursor: pointer;
      height: 40px;
      line-height: 40px;
      padding-left: 10px;
    }
    .description {
      font-size: 1.2rem;
      line-height: 40px;
    }
  }
}
</style>
